'use strict';

import Api from "./Api";

export default class Visit extends Api {

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = [], parameters = {}) {
        const url = this.url + 'visit/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
                expand: extraFields.join(','),
                ...parameters,
            },
        });
    }

    static get(id) {
        const url = this.url + 'visit/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static getBySchedule(scheduleId) {
        const url = this.url + 'visit/get-by-schedule';

        return this.getAxios().get(url, {
            params: {
                scheduleId: scheduleId,
            },
        });
    }

    static getMyVisitReservation(clientId) {
        const url = this.url + 'client/get-my-visits-reservation';

        return this.getAxios().get(url, {
            params: {
                id: clientId,
            },
        });
    }

    static add(scheduleId, clientId, clientSubscriptionId) {
        const url = this.url + 'visit/add';

        return this.getAxios().post(url, {
            scheduleId: scheduleId,
            clientId: clientId,
            clientSubscriptionId: clientSubscriptionId,
        });
    }

    static addReservation(scheduleId, clientId, clientSubscriptionId) {
        const url = this.url + 'visit/add-reservation';

        return this.getAxios().post(url, {
            scheduleId: scheduleId,
            clientId: clientId,
            clientSubscriptionId: clientSubscriptionId,
        });
    }

    static update(data) {
        const url = this.url + 'visit/update';

        return this.getAxios().post(url, data);
    }

    static remove(id) {
        const url = this.url + 'visit/remove';

        return this.getAxios().post(url, {id: id});
    }

}
